var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.2,
    height: 35.2,
    rx: 17.6,
    fill: "#D5FFE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_8315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3918 9.46007L15.6263 12.6945C16.1035 13.1717 16.1035 13.956 15.6263 14.4332L14.4332 15.6262C13.956 16.1034 13.1717 16.1034 12.6945 15.6262L9.4601 12.3918C8.87463 11.8063 7.88044 12.1201 7.72358 12.9331C7.31707 15.0165 7.92021 17.2567 9.533 18.8717C11.3468 20.6855 13.956 21.2224 16.2404 20.4823L21.5649 25.8067C22.6231 26.865 24.3574 26.865 25.4157 25.8067L25.8067 25.4156C26.865 24.3574 26.865 22.6231 25.8067 21.5648L20.4823 16.2404C21.2224 13.956 20.6856 11.3468 18.8717 9.53297C17.2567 7.91797 15.0165 7.31704 12.9331 7.72355C12.1201 7.88262 11.8064 8.8746 12.3918 9.46007Z",
    fill: "#00C18A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5499 22.3072C25.1685 22.9258 25.1685 23.9311 24.5499 24.5497C23.9313 25.1683 22.9261 25.1683 22.3075 24.5497C21.6889 23.9311 21.6889 22.9258 22.3075 22.3072C22.9261 21.6886 23.9313 21.6886 24.5499 22.3072Z",
    fill: "#A6F4C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_8315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(7.6001 7.6001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.f9aaf63d619f9b459ea301be4ac9d421.svg";
export { ForwardRef as ReactComponent };